import React, { useState, useEffect } from 'react';
import steeper from '../assets/img/steeper.png';
import demo1 from '../assets/css/demo1.css';
import axios from 'axios';
import '../page/Tracking.css'
import track from '../assets/img/track.png';
import Button from '@mui/material/Button';
import world from '../assets/img/world.png';
import { Outlet, Link } from "react-router-dom";

function Tracking({ item }) {
  const [payload, setPayload] = useState('');
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
    const [activeCntrNo, setActiveCntrNo] = useState(null);
    const [activeCntrid, setActiveCntrid] = useState(null);
  const [loading, setLoading] = useState(false);

  const [status, setStatus] = useState(null);
  const [blNumber, setBlNumber] = useState('');


    useEffect(() => {
        // Fetch status from API
        fetch('https://oceanus-lines.com/api/OnLIne/OnlineCntrTraking')
            .then(response => response.json())
            .then(data => {
                // Assuming the status is available in data.status
                setStatus(data.status);
            })
            .catch(error => {
                console.error('Error fetching status:', error);
            });
    }, []);

    const handleClick = (CntrNo, CntrId, BLID) => {

        if (CntrId) {

            // Construct the URL with both Container Number and BLNumber
            window.location.href = `/ContainerDamage?CntrId=${CntrId}&blid=${BLID}`;
        } else {
            console.error("Container number is null.");
        }
    };


    const handleCntrNoClick = (cntrNo, CntrID) => {

        setActiveCntrNo(cntrNo);
        setActiveCntrid(CntrID);
    };

    useEffect(() => {
        // Check if there's an activeCntrNo stored in local storage
        const storedActiveCntrNo = localStorage.getItem('activeCntrNo');
        const storedActiveCntrid = localStorage.getItem('activeCntrid');
        if (storedActiveCntrNo) {
            setActiveCntrNo(storedActiveCntrNo);
            setActiveCntrid(storedActiveCntrid);
        }
    }, []);

    useEffect(() => {
        // Whenever activeCntrNo changes, store it in local storage
        localStorage.setItem('activeCntrNo', activeCntrNo);
    }, [activeCntrNo], [activeCntrid]);

    useEffect(() => {
        if (payload) {
            fetchData();
        } else {
            setData([]);
            setFilteredData([]);
            setError('Search & Find the Container Movements');
        }
    }, [payload]);

    const fetchData = async () => {
        try {
            setLoading(true); // Set loading to true when fetching data starts
            const response = await axios.post('https://oceanus-lines.com/api/OnLIne/OnlineCntrTraking',
                {
                    Textvalues: payload
                });
            if (response.data.length > 0) {
                setData(response.data);
                setFilteredData(response.data);
                setError('');
            } else {
                window.alert('No data found for the entered BL Number. Please enter a valid BL Number.');
                setError('No data found for the entered BL Number. Please enter a valid BL Number.');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setData([]);
            setFilteredData([]);
            setError('The BL Number is invalid. Please enter a valid BL Number.');
        } finally {
            setLoading(false); // Set loading to false when data fetching completes
        }
    };

    const handleInputChange = (event) => {
        setPayload(event.target.value);
    };

    const handleSearch = () => {
        if (payload) {
            setTimeout(() => {
                fetchData();
            }, 10000);
        } else {
            setFilteredData(data);
        }
    };


  return (
    <div>
      {loading && (
        <div className="loading-container">
          <div className="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}
      <div className="page-wrapper">
        <section className="banner-section-four">
          <div className="auto-container">
            <div className="cotnent-box">
              <div className="title-box aos-init aos-animate" data-aso-delay="500" data-aos="fade-up">
                <h3>Find the Container/BL Tracking</h3>
              </div>
              <div className="job-search-form aos-init aos-animate" data-aos-delay="700" data-aos="fade-up">
                <div className="row">
                  <div className="form-group col-lg-10 col-md-12 col-sm-12">
                    <span className="icon"></span>
                    <input
                      type="text"
                      id="containerNo"
                      placeholder="BL Number, Container Number, Booking Number"
                      value={payload}
                      onChange={handleInputChange}
                    />
                  </div>
                  {/* <div className="form-group col-lg-2 col-md-12 col-sm-12 text-right">
                    <button onClick={fetchData}><i className="las la-search"></i></button>
                  </div> */}
                </div>
              </div>
              {/* <p>Search & Find the Container Movements</p> */}
              {error && <p className="error-message">{error}</p>}
            </div>
            <div className="popular-searches aos-init aos-animate" data-aos="fade-up" data-aos-delay="1000">
              <span className="title"></span>
            </div>
          </div>
        </section>

      </div>
      {data.length > 0 && (
        <div>
          {data.map((item, index) => (
            // <li key={index}>{item.BLNumber}</li>
            <section class="job-section alternate mb-5" key={index}>
              <div class="auto-container">
                <div class="sec-title text-center">
                  <h2>Shipment Details</h2>
                </div>
                <div class="col-md-10 offset-md-1 pl">
                  <div class="row aos-init aos-animate" data-aos="fade-up" data-aos-anchor-placement="top-bottom">
                    <div class="category-block col-lg-4 col-md-6 col-sm-12">
                      <div class="inner-box">
                        <div class="content"><span class="icon"><i class="las la-plus-square"></i></span>
                          <h4><a>BL/Booking Number</a></h4>
                          <p>{item.BLNumber}</p>
                        </div>
                      </div>
                    </div>
                    <div class="category-block col-lg-4 col-md-6 col-sm-12">
                      <div class="inner-box">
                        <div class="content"><span class="icon"><i class="las la-redo-alt"></i></span>
                          <h4><a>Port of Loading</a></h4>
                          <p>{item.POL}</p>
                        </div>
                      </div>
                    </div>
                    <div class="category-block col-lg-4 col-md-6 col-sm-12">
                      <div class="inner-box">
                        <div class="content"><span class="icon"><i class="las la-redo-alt"></i></span>
                          <h4><a>Port of Discharge</a></h4>
                          <p>{item.POD}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container mt-5">
                <div class="row">
                  <div class="col-md-12">
                    <div class="category-block col-lg-12 text-center mb-5">
                      <div class="row">
                        <div class="col-md-4 pol">
                          <p>{item.POL}</p>
                        </div>
                        <div class="col-md-4 tsport">
                          <p>{item.TSPort}</p>
                        </div>
                        <div class="col-md-4 pod">
                          <p>{item.POD}</p>
                        </div>
                      </div>
                      <img src={steeper} width="650px" />
                      <div class="row">
                        <div class="col-md-3 offset-md-3 polb">
                          <p>{item.POL}</p>
                        </div>
                        <div class="col-md-3 podb">
                          <p>{item.POD}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-content page-container" id="page-content" style={{ backgroundImage: `url(${world})` }}>
                <div className="padding">
                  <div className="row container d-flex justify-content-center">
                    <div class="row">
                      <div className="col-md-3">
                        <div className="d-grid gap-2 d-md-flex">
                          {status !== 293 && (
                           <Button
                           variant="contained"
                           style={{ backgroundColor: '#0E5E6F' }}
                                                  onClick={() => handleClick(activeCntrNo, activeCntrid, item.BLID)} // Pass activeCntrNo to handleCntrNoClick
                            >
                           View Container Damage
                         </Button> 
                          )}
                        </div>
                      </div>
                      <div className="col-md-9">
                        <div className="sec-title mb-5">
                          <h2 style={{ textAlign: 'center' }}>
                            <img src={track} alt="" width="50px" />
                            Track the Container
                          </h2>
                        </div>
                      </div>
                    </div>

                    <div className="container">
                      <div className="row">
                        <div className="col-lg-3 col-md-12" style={{ borderRight: '1px solid rgb(117 117 117 / 30%)', padding: '0px' }}>
                          <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            {item.OnlineCntrDtls_list
                              .filter((cntr, index, self) => self.findIndex(c => c.CntrNo === cntr.CntrNo) === index)
                              .map((cntr, i) => (
                                  <button className={`nav-link ${i === 0 ? 'active' : ''}`} id={`v-pills-${cntr.CntrNo}-tab`} data-bs-toggle="pill" href={`#v-pills-${cntr.CntrNo}`} role="tab" aria-controls={`v-pills-${cntr.CntrNo}`} aria-selected={i === 0} onClick={() => handleCntrNoClick(cntr.CntrNo, cntr.CntrID)} key={i}>
                                  {cntr.CntrNo}
                                </button>
                              ))}
                          </div>
                        </div>
                        <div className="col-lg-9 col-md-12">
                          <div className="tab-content" id="v-pills-tabContent">
                            {item.OnlineCntrDtls_list
                              .filter((cntr, index, self) => self.findIndex(c => c.CntrNo === cntr.CntrNo) === index)
                              .map((cntr, i) => (
                                <div className={`tab-pane fade ${i === 0 ? 'show active' : ''}`} id={`v-pills-${cntr.CntrNo}`} role="tabpanel" aria-labelledby={`v-pills-${cntr.CntrNo}-tab`} key={i}>
                                  <div className="history-tl-container">
                                    <ul className="tl">
                                      {cntr.OnlineCntrMovementDtls_list.map((movement, j) => (
                                        <li key={j} className={j % 2 === 1 ? 'tl-left' : 'tl-right'}>
                                          <div className="timestamp">{movement.DtMovement}</div>
                                          <div className="item-title"><b>({movement.StatusDes})</b> {movement.Description}</div>
                                          <p className="item-title">Vessel : {movement.Vesvoy}</p>
                                          <p className="item-title">Port : {movement.Port}</p>
                                          <p className="item-title">Depo : {movement.Depo}</p>
                                          <div className="item-detail">{movement.Details}</div>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>

                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ))}
        </div>
      )}

    </div>
  );
}

export default Tracking;
